export const server = {
  DEFAULT_DATE_FORMAT: 'year/month/day',
  VERSION: '15.7'
}

export const tipoAnalisisControlMorfologicoSeguimiento = {
  ANALISIS: 1,
  CONTROL_MORFOLOGICO: 2,
  SEGUIMIENTO: 3
}